import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithErrorHandling from './baseQuery';
import { Constants } from '../constants/Constants';

const { BASE_API_URL } = Constants;

export interface TrendDataResponse {
    variable_name: string;
    description: string;
    type: string;
    unit: string;
    x_axis_description: string;
    x_axis_unit: string;
    y_axis_description: string;
    y_axis_unit: string;
}

export interface TrendDataParams {
    object_interpretation_id: string;
    ecu_part_numbers?: string;
}

const customBaseQuery = async (args: any, api: any, extraOptions: any) => {
    const baseQuery = baseQueryWithErrorHandling({ baseUrl: BASE_API_URL });
    return baseQuery(args, api, extraOptions);
};

export const trendDataApi = createApi({
    reducerPath: 'trendDataApi',
    baseQuery: customBaseQuery,
    endpoints: builder => ({
        getTrendData: builder.query<TrendDataResponse, TrendDataParams>({
            query: params => {
                return {
                    url: '/historical/metadata/trenddata',
                    method: 'GET',
                    params: {
                        object_interpretation_id: params.object_interpretation_id,
                        ecu_part_numbers: params.ecu_part_numbers,
                    },
                };
            },
            transformResponse: (response: TrendDataResponse[]) => {
                if (Array.isArray(response) && response.length > 0) {
                    return response[0];
                }

                return {} as TrendDataResponse;
            },
        }),
    }),
});

export const { useGetTrendDataQuery, useLazyGetTrendDataQuery } = trendDataApi;
